import { Dialog, Button, Text, Flex } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

const UnsavedChangesModal = ({ isOpen, onClose, onDiscard, onSave }) => {
  const { t } = useTranslation('shared');

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Content style={{ padding: 0 }}>
        <Flex direction="column" p="24px">
          <Text as="div" size="5" weight="bold">
            {t('unsavedChangesModal.title')}
          </Text>
          <Text as="div" size="3" weight="medium" mt="4">
            {t('unsavedChangesModal.body')}
          </Text>
          <Flex justify="end" gap="3" mt="6">
            <Button variant="outline" size="3" onClick={onClose}>
              {t('unsavedChangesModal.stay')}
            </Button>
            <Button variant="outline" size="3" onClick={onDiscard}>
              {t('unsavedChangesModal.discard')}
            </Button>
            <Button variant="solid" size="3" onClick={onSave}>
              {t('unsavedChangesModal.save')}
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default UnsavedChangesModal;
